import { useEffect, useState } from "react";
import { Loader2, Radio, Square } from "lucide-react";
import { api } from "@/lib/api";

// Today's digest: the stories MiLu picked, with one button to hear the lot.
export const DigestPanel = ({ speaker, lang }) => {
  const [digest, setDigest] = useState(null);

  useEffect(() => {
    api.get("/news/digest", { params: { lang } })
      .then(({ data }) => setDigest(data))
      .catch((e) => console.error("could not load today's digest", e));
  }, [lang]);

  if (!digest) {
    return (
      <div className="mt-4 flex items-center gap-2 text-xs text-ink-soft" data-testid="home-digest-panel">
        <Loader2 className="h-3.5 w-3.5 animate-spin" /> Gathering today's digest…
      </div>
    );
  }

  const reading = speaker.playing === "/news/digest/say";

  return (
    <div className="mt-4 rounded-2xl border border-white/10 bg-page p-4" data-testid="home-digest-panel">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-brand">
          Your daily digest · {digest.picks.length} {digest.picks.length === 1 ? "story" : "stories"}
        </p>
        <button
          data-testid="home-digest-listen"
          onClick={() => speaker.play("/news/digest/say",
            async () => (await api.get("/news/digest/say", { params: { lang } })).data.text)}
          disabled={Boolean(speaker.loading)}
          className="ms-auto inline-flex min-h-[34px] items-center gap-2 rounded-full border border-brand/40 px-4 text-xs font-semibold text-brand transition-colors hover:bg-brand/10 disabled:opacity-50"
        >
          {speaker.loading === "/news/digest/say" ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : reading ? <Square className="h-3.5 w-3.5" /> : <Radio className="h-3.5 w-3.5" />}
          {reading ? "Stop" : "Read it to me"}
        </button>
      </div>

      {digest.picks.length === 0 ? (
        <p className="mt-3 text-sm text-ink-soft" data-testid="home-digest-empty">
          Nothing in it yet — pick a topic or two in your preferences and it will fill up.
        </p>
      ) : (
        <ul className="mt-3 space-y-2">
          {digest.picks.map((pick) => (
            <li key={pick.url || pick.title} data-testid="home-digest-story">
              <a
                href={pick.url}
                target="_blank"
                rel="noreferrer"
                className="block rounded-2xl border border-white/10 bg-panel p-3 transition-colors hover:border-brand/40"
              >
                <span className="block text-[11px] uppercase tracking-widest text-ink-soft">{pick.label}</span>
                <span dir="auto" className="mt-0.5 block text-sm font-semibold">{pick.title}</span>
                {pick.source && <span className="mt-0.5 block text-xs text-ink-soft">{pick.source}</span>}
              </a>
            </li>
          ))}
        </ul>
      )}

      {!digest.ready && (
        <p className="mt-3 text-xs text-ink-soft" data-testid="home-digest-early">
          Today's digest lands at {String(digest.hour).padStart(2, "0")}:00 your time — this is an early look.
        </p>
      )}
    </div>
  );
};
